import { IAuditLog } from "../models";
import { AuthenticatedFetch, CreateAuthHeader } from "../utils/Helpers";

export interface IAuditLogService
{
    GetAll(from: Date, to: Date): Promise<IAuditLog[]>;
    LogLogout(): Promise<void>;
}

export class AuditLogServiceProvider implements IAuditLogService
{
    private controller = "api/auditlogs";

    public async GetAll(from: Date, to: Date): Promise<IAuditLog[]>
    {
        const requestOptions = {
            method: 'GET',
            headers: CreateAuthHeader()
        };

        const query = `?from=${encodeURIComponent(from.toISOString())}&to=${encodeURIComponent(to.toISOString())}`;
        const response = await AuthenticatedFetch(this.controller + query, requestOptions);
        if (!response.ok) {
            throw new Error("Error fetching audit log");
        }

        const result = await response.json() as IAuditLog[];
        return result.map(i => ({ ...i, created: new Date(i.created) }));
    }

    public async LogLogout(): Promise<void>
    {
        const requestOptions = {
            method: 'POST',
            headers: CreateAuthHeader()
        };

        await fetch(`${this.controller}/logout`, requestOptions);
    }
}
